'use es6';

import PropTypes from 'prop-types';
import { List, Map as ImmutableMap, fromJS } from 'immutable';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import DealStage from 'customer-data-objects/deal/DealStage';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const ProbabilityBarStylesWrapper = styled.div.withConfig({
  displayName: "ProbabilityBar__ProbabilityBarStylesWrapper",
  componentId: "z895e-0"
})(["", ""], ({
  theme
}) => `
    padding: 8px 0;

    .probability-bar-container {
      display: flex;
      gap: ${theme.space[80]};
    }

    .probability-bar {
      height: 4px;
      transition: background-color 250ms ease;
      border-radius: 4px;
      flex: 1;
    }

    .probability-color-empty {
      background-color: ${theme.color['fill-tertiary-default']};
    }

    .probability-color-0 {
      background-color: ${theme.color['fill-accent-neutral-hover']};
    }

    // These should probably be constants somewhere or created on the fly by a gradient
    .probability-color-10 { background-color: #fea58e; }
    .probability-color-20 { background-color: #fb9d95; }
    .probability-color-30 { background-color: #f7969c; }
    .probability-color-40 { background-color: #ef91a4; }
    .probability-color-50 { background-color: #e68cab; }
    .probability-color-60 { background-color: #da89b2; }
    .probability-color-70 { background-color: #cc87b8; }
    .probability-color-80 { background-color: #bc85bd; }
    .probability-color-90 { background-color: #aa85c0; }
    .probability-color-100 { background-color: #9784c2; }
  `);
const DEFAULT_STAGES = fromJS([{
  probability: 0.1,
  displayOrder: 0
}, {
  probability: 0.2,
  displayOrder: 1
}, {
  probability: 0.3,
  displayOrder: 2
}, {
  probability: 0.4,
  displayOrder: 3
}, {
  probability: 0.5,
  displayOrder: 4
}, {
  probability: 0.6,
  displayOrder: 5
}, {
  probability: 0.7,
  displayOrder: 6
}, {
  probability: 0.8,
  displayOrder: 7
}, {
  probability: 0.9,
  displayOrder: 8
}, {
  probability: 1,
  displayOrder: 9
}, {
  probability: 0,
  displayOrder: 10
}]);
const ProbabilityBar = ({
  currentStage,
  stages
}) => {
  const getColorProbability = stage => {
    const isZeroProbabilityCurrentStage = currentStage.get('probability') === 0 && currentStage.get('stageId') !== stage.get('stageId');
    const isAfterCurrentStage = stage.get('displayOrder') > currentStage.get('displayOrder');
    if (isZeroProbabilityCurrentStage || isAfterCurrentStage) {
      return 'empty';
    }
    const probability = stage.get('probability') * 100;
    return Math.ceil(probability / 10) * 10;
  };
  const renderStage = (stage, index) => {
    const colorClass = getColorProbability(stage);
    const bar =
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("div", {
      "data-selenium-test": "probability-bar-stage",
      "data-test-id": "probability-bar-stage",
      className: `probability-bar probability-color-${colorClass}`
    }, index);
    if (currentStage.get('stageId') === stage.get('stageId') || stages.size > 11 && currentStage.get('probability') === stage.get('probability')) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: currentStage.get('label'),
        children: bar
      }, index);
    }
    return bar;
  };
  const stagesToRender = stages.size <= 11 ? stages : DEFAULT_STAGES;
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(ProbabilityBarStylesWrapper, {
      children: /*#__PURE__*/_jsx("div", {
        className: "probability-bar-container",
        children: stagesToRender.map(renderStage)
      })
    })
  );
};
ProbabilityBar.propTypes = {
  currentStage: PropTypes.oneOfType([PropTypes.instanceOf(ImmutableMap), PropTypes.instanceOf(DealStage)]).isRequired,
  stages: PropTypes.instanceOf(List).isRequired
};
export default ProbabilityBar;